// 公用页面 如首页 404 等页面
export default [
  {
      path: '/*', //404
      meta: {
          title: '页面暂未找到',
      },
      component: () =>import('@/views/home/index')
  },
]


// WEBPACK FOOTER //
// ./src/router/common.js